require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cohort-v-mentors.json") })
        }
      }, "path---cohort-v-mentors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cohort-v-mentors!./.cache/json/cohort-v-mentors.json
// module id = 638
// module chunks = 231608221292675